import { toast } from '@qodo/design-system';
import { useMutation } from '@tanstack/react-query';
import { spawn } from '../../utils/translations';
import {
  GitlabClient,
  GitlabConfigureRequest,
} from '../httpClients/GitlabClient';
import { MUTATION_KEYS } from './consts';
import { getErrorToastContent } from './utils';

export const useConfigureGitlabMutation = () => {
  const spawnToasts = spawn('toasts.gitlab.configure');

  return useMutation({
    mutationKey: [MUTATION_KEYS.CONFIGURE_GITLAB],
    mutationFn: async (request: GitlabConfigureRequest) => {
      await GitlabClient.configure(request);
    },
    onError: (err: unknown) => {
      const errorFromServer = getErrorToastContent(err, spawnToasts('error'));

      toast.error(errorFromServer);
    },
  });
};
